"use strict";

/**
 * Виджет позиционирует дату внутри калледарной ячейки
 */

$.widget("fotobook.calendarNumbersAlignment", $.fotobook.containereditorbasecontrol, {
    calendar : null,
    numbersAlign : null,
    numbersVerticalAlign : null,

    _create: function() {
        this.calendar = Fotobook.containers.calendar;
        this.numbersAlign = parseInt($(this.element).attr("data-horizontal_align"), 10);
        this.numbersVerticalAlign = parseInt($(this.element).attr("data-vertical_align"), 10);
        this._super();
    },
    _processClick: function() {
        return this.calendar.editor.changeAlignment(this.options.container, this.numbersVerticalAlign, this.numbersAlign)
               .then(() => this._changeAlignmentInEditor(this.options.container));
    },
    /**
     *TODO Вынести из виджета. Возможно нужно создать метод подобный Fotobook.containers.calendar.changeAttribute
     */
    _changeAlignmentInEditor: function(container) {
        $(container).attr('data-numbers_align', this.numbersAlign);
        $(container).attr('data-numbers_vertical_align', this.numbersVerticalAlign);
    },
    getAlignValue: function(){
        return parseInt(this.options.container.attr('data-numbers_align'), 10);
    },
    getVerticalAlignValue: function(){
        return parseInt(this.options.container.attr("data-numbers_vertical_align"), 10);
    },
    _isButtonActive: function(){
        return (this.getAlignValue() === this.numbersAlign) && (this.getVerticalAlignValue() === this.numbersVerticalAlign);
    },
    _containerChanged: function(){
        var enabled = this._isButtonActive();
        this.element.toggleClass("active", enabled );
        this._super();
    },
});